module.exports = __webpack_public_path__ + "img/warning.b6d41670.png";